import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

const STORAGE_NAME = 'closure_period';
export const useClosurePeriodStore = defineStore('closure_period', () => {
  const closurePeriod = ref(localStorage.getItem(STORAGE_NAME));

  const getClosurePeriod = computed(() => closurePeriod.value);
  const setClosurePeriod = (val: string) => {
    closurePeriod.value = val;
    localStorage.setItem(STORAGE_NAME, val);
  };

  const deleteClosurePeriod = () => {
    closurePeriod.value = null;
    localStorage.removeItem(STORAGE_NAME);
  };

  return { getClosurePeriod, setClosurePeriod, deleteClosurePeriod };
});
